// extracted by mini-css-extract-plugin
export default {"wrapper":"Profile_wrapper__80dUp","profileMainContainer":"Profile_profileMainContainer__tU-Ml"};